import { Component, OnInit } from '@angular/core';
import { AppConstant } from 'src/app/helper/class/app-constant';

@Component({
  selector: 'app-user-footer',
  templateUrl: './user-footer.component.html',
  styleUrls: ['./user-footer.component.scss'],
  standalone: true
})
export class UserFooterComponent implements OnInit {

  year = new Date().getFullYear()
  logo_url = AppConstant.LOGO_SRC
  constructor() { }

  ngOnInit(): void {
  }

}
